import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appDialogTemplateInjector]',
  exportAs: 'injector',
})
export class DialogTemplateInjectorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
